import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"

/**
 * PlaceholderPage — temporary stand-in for routes that haven't been built yet.
 * Each real page will replace this in subsequent batches (Login → Users →
 * Videos → ... ).
 */
export default function PlaceholderPage({
  name,
  note,
}: {
  name: string
  note?: string
}) {
  return (
    <div className="mx-auto max-w-3xl">
      <Card>
        <CardHeader>
          <CardTitle>{name}</CardTitle>
          <CardDescription>
            {note ?? "This page hasn't been migrated to admin-v2 yet."}
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-2 text-sm text-muted-foreground">
          <p>
            The shell, navigation, and design system are in place. Real
            functionality lands in the next batches.
          </p>
          <p>
            Use the legacy admin (apps/admin) for any task this page would
            normally do.
          </p>
        </CardContent>
      </Card>
    </div>
  )
}
